import request from './request'

export function getAdminDashboard() {
  return request.get('/biz/admin-home/dashboard')
}

export function listStageDefs(params) {
  return request.get('/biz/stage-defs', { params })
}
export function saveStageDef(data) {
  return request.post('/biz/stage-defs', data)
}
export function deleteStageDef(id) {
  return request.delete(`/biz/stage-defs/${id}`)
}

export function listHouseTypes(params) {
  return request.get('/biz/house-types', { params })
}
export function getHouseType(id) {
  return request.get(`/biz/house-types/${id}`)
}
export function saveHouseType(data) {
  return request.post('/biz/house-types', data)
}
export function deleteHouseType(id) {
  return request.delete(`/biz/house-types/${id}`)
}

export function listProjects(params) {
  return request.get('/biz/projects', { params })
}
export function getProject(id) {
  return request.get(`/biz/projects/${id}`)
}
export function createProject(data) {
  return request.post('/biz/projects', data)
}
export function updateProject(id, data) {
  return request.put(`/biz/projects/${id}`, data)
}
export function completeProject(id, force) {
  return request.post(`/biz/projects/${id}/complete`, null, {
    params: force ? { force: true } : undefined
  })
}
export function startProject(id) {
  return request.post(`/biz/projects/${id}/start`)
}
export function reopenProject(id) {
  return request.post(`/biz/projects/${id}/reopen`)
}
export function deleteProject(id) {
  return request.delete(`/biz/projects/${id}`)
}

export function listProjectStages(params) {
  return request.get('/biz/project-stages', { params })
}
export function getProjectStage(id) {
  return request.get(`/biz/project-stages/${id}`)
}
export function exportProjectStages(params) {
  return request.get('/biz/project-stages/export', { params, responseType: 'blob' })
}
export function addProjectStage(data) {
  return request.post('/biz/project-stages', data)
}
export function updateProjectStagePlan(id, data) {
  return request.post(`/biz/project-stages/${id}/plan`, data)
}
export function deleteProjectStage(id) {
  return request.delete(`/biz/project-stages/${id}`)
}
export function startStage(id) {
  return request.post(`/biz/project-stages/${id}/start`)
}
export function completeStage(id) {
  return request.post(`/biz/project-stages/${id}/complete`)
}

export function listEvaluateTpls(params) {
  return request.get('/biz/evaluate-tpls', { params })
}
export function listEvaluateTplOptions() {
  return request.get('/biz/evaluate-tpls/options')
}
export function getEvaluateTpl(id) {
  return request.get(`/biz/evaluate-tpls/${id}`)
}
export function saveEvaluateTpl(data) {
  return request.post('/biz/evaluate-tpls', data)
}
export function deleteEvaluateTpl(id) {
  return request.delete(`/biz/evaluate-tpls/${id}`)
}

export function listProjectNotices(projectId) {
  return request.get('/biz/project-notices', { params: { projectId } })
}

export function listProjectPictures(projectId, pictureType) {
  return request.get('/biz/project-pictures', {
    params: { projectId, pictureType: pictureType || 'all' }
  })
}

export function listProjectSignins(params) {
  return request.get('/biz/project-signins', { params })
}
export function exportProjectSignins(params) {
  return request.get('/biz/project-signins/export', { params, responseType: 'blob' })
}
export function getProjectSignin(id) {
  return request.get(`/biz/project-signins/${id}`)
}
